export const ROUTE_PATHS = {
	LOGIN: "/login",
	FORGOT_PASSWORD: "/forgot-password",
	RESET_PASSWORD: "/reset-password",
	CHANGE_PASSWORD: "/change-password",
	DASHBOARD: "/",
	NOTIFICATION: "/notification",
	CHATS: '/chats',
  CHAT_DETAIL: '/chats/:eventId/:chatId',
	ADMIN_VENDOR_CHAT: '/chats/support',
	ACTIVE_EVENTS: "/events",
	IN_PROGRESS_EVENTS: "/events/in-progress",
	DIRECTORY_REQUEST_EVENTS: "/events/direct-requests",
	AI_DIRECT_REQUEST: "/events/ai-direct-requests",
	APPROVED_EVENTS: "/events/approved",
	EVENT_DETAIL: "/event-detail/:id",
	EVENT_HISTORY_DECLINED: "/events-history/declined",
	EVENT_HISTORY_COMPLETED: "/events-history/completed",
	PRE_PAID_REQUESTS: "/pre-paid-requests",
	B2B: {
		ACTIVE_EVENTS: "/b2b/active",
		APPROVED_EVENTS: "/b2b/approved",
		DECLINED_EVENTS: "/b2b/declined",
		COMPLETED_EVENTS: "/b2b/completed",
		EVENT_DETAIL: "/b2b/events/:id",
	},
	QUOTE_FORM: "/quote-form",
};

export enum ROUTE_QUERY_PARAMS {
	NOTIFICATION_ID = "notificationId",
}

export enum ROUTE_QUERY_CONSTANTS {
	InProgress = "in_progress",
	EventDirectory = "event_directory",
	ActiveEvents = "active_events",
	AiDirectRequest = "ai_requests",
	DirectRequests = "direct_request",
	Approved = "approved",
	Declined = "declined",
	EventHistory = "event_history",
	Completed = "completed",
	PrePaidRequests = "pre_paid_requests",
	CorporateActiveEvents = "corporate_active",
	CorporateApprovedEvents = "corporate_approved",
	CorporateDeclinedEvents = "corporate_declined",
	CorporateCompletedEvents = "corporate_completed",
}

export enum SIDE_BAR_SECTIONS {
	Consumer = "b2c",
	CORPORATE = "b2b",
}
